<div class="dance-home-page">
  <app-hero-section></app-hero-section>
  <app-location-banner></app-location-banner>
  <app-nearby-classes></app-nearby-classes>
  <app-nearby-events></app-nearby-events>
  <app-nearby-workshops></app-nearby-workshops>
  <app-popular-events></app-popular-events>
  <app-newsletter></app-newsletter>
</div>
